import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="relative py-16 md:py-24 px-4 md:px-6 overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Cozy%20warm%20family%20living%20room%20with%20soft%20sunlight%2C%20playful%20children%20toys%20scattered%20on%20wooden%20floor%2C%20cream%20walls%2C%20green%20plants%2C%20minimalist%20Scandinavian%20interior%2C%20warm%20atmosphere%20with%20gentle%20shadows&width=1800&height=600&seq=cta-bg-home&orientation=landscape"
        alt=""
        className="absolute inset-0 w-full h-full object-cover"
        loading="lazy"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/25 to-black/40"></div>
      <div className="relative z-10 text-center max-w-2xl mx-auto">
        <h2 className="font-heading text-2xl md:text-4xl text-background-50 mb-4">
          准备好了吗？一起陪宝宝度过精彩的三岁
        </h2>
        <p className="text-background-50/85 text-sm md:text-base mb-8 leading-relaxed">
          立即加入悠宝三岁，获取专属于您宝宝的个性化成长方案
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/category"
            className="px-8 py-3 bg-primary-500 text-background-50 rounded-full text-sm md:text-base font-medium hover:bg-primary-600 transition-all hover:scale-105 whitespace-nowrap cursor-pointer"
          >
            免费获取成长方案
            <i className="ri-arrow-right-line ml-2"></i>
          </Link>
          <a
            href="tel:400-123-4567"
            className="px-8 py-3 bg-background-50/15 backdrop-blur-sm text-background-50 border border-background-50/30 rounded-full text-sm md:text-base font-medium hover:bg-background-50/25 transition-all whitespace-nowrap cursor-pointer"
          >
            <i className="ri-phone-line mr-2"></i>
            咨询育儿顾问
          </a>
        </div>
      </div>
    </section>
  );
}